/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { RequiredValidation, Select } from 'sarsaparilla';
import { getClassName } from '../../utils/utils';

const ISSUE_STATION_PROP_PATH = 'issue_station';

export default function IssueStationSelector({
    reservation,
    validation,
    displayValidationError,
    permit,
    pActions,
}) {
    const onFormValidate = useCallback((isInValid, error, path) => {
        if (isInValid) {
            pActions.formValidationChange(path, error);
        } else {
            pActions.formValidationChange(path, null);
        }
    }, []);

    const changeIssueStation = useCallback((event) => {
        pActions.updatePendingReservation(
            reservation.id,
            ISSUE_STATION_PROP_PATH,
            event.target.value
        );
    }, []);

    const { id } = reservation;
    const issueStation = get(reservation, `${ISSUE_STATION_PROP_PATH}`, '');
    const issueStationValidation = getClassName(
        get(validation, `${id}_${ISSUE_STATION_PROP_PATH}`),
        displayValidationError
    );
    const dropdownOptions = permit?.entrances.map((th) => ({
        label: th.name,
        value: th.id,
    }));

    return (
        <div className="permit-vehicle-wrap">
            <div className="rec-nested-wrap">
                <div className="rec-grid-12-12">
                    <div className="form-section-header">Issuing Station</div>
                    <p>
                        You will be required to pick up your permit in person at the below
                        location. Your confirmation email will have further instructions.
                    </p>
                </div>
                <div className="rec-grid-12-12">
                    <div className="rec-nested-wrap">
                        <div className="rec-grid-4-12">
                            <Select
                                className={issueStationValidation}
                                label="Issue Station"
                                id="issue_station"
                                placeholder="Select an issue station"
                                options={dropdownOptions}
                                onChange={changeIssueStation}
                                value={issueStation}
                                isRequired
                            />
                            <RequiredValidation
                                value={issueStation}
                                displayInSummary
                                onValidated={(isInValid, error) =>
                                    onFormValidate(
                                        isInValid,
                                        error,
                                        `${ISSUE_STATION_PROP_PATH}`
                                    )
                                }
                                controlLabel="Issue Station"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

IssueStationSelector.propTypes = {
    reservation: PropTypes.object.isRequired,
    validation: PropTypes.object.isRequired,
    displayValidationError: PropTypes.bool,
    permit: PropTypes.object.isRequired,
    pActions: PropTypes.shape({
        formValidationChange: PropTypes.func.isRequired,
        updatePendingReservation: PropTypes.func.isRequired,
    }),
};
